import { TBoundAction } from '../actions/types/action';

type TEventTeamDetailsResponse = Record<string, any>;

type TEventTeamsState = {
  viewEventTeamDetails: TViewEventTeamDetailsState;
};

export type TViewEventTeamDetailsState = {
  request: TViewEventTeamDetailsRequestedParams;
  response: TEventTeamDetailsResponse;
  isRequested: boolean;
  isSucceeded: boolean;
  isErrored: boolean;
  error?: any;
};

// event team details
type TViewEventTeamDetailsRequestedParams = {
  team: string;
  namespace: string;
};

type TViewEventTeamDetailsSucceededParams = {
  results: TEventTeamDetailsResponse;
};

type TViewEventTeamDetailsFailedParams = TViewEventTeamDetailsRequestedParams & {
  error: any;
};

export const enum ActionTypes {
  SET_EVENT_TEAM_DETAILS_REQUESTED = 'TEAM/VIEW_EVENT_TEAM_DETAILS_REQUESTED',
  SET_EVENT_TEAM_DETAILS_SUCCEEDED = 'TEAM/VIEW_EVENT_TEAM_DETAILS_SUCCEEDED',
  SET_EVENT_TEAM_DETAILS_FAILED = 'TEAM/EVENT_TEAM_DETAILS_FAILED'
}

// team details
export type TActionEventTeamDetailsRequested = TBoundAction<
  ActionTypes.SET_EVENT_TEAM_DETAILS_REQUESTED,
  TViewEventTeamDetailsRequestedParams
>;
type TActionEventTeamDetailsSucceeded = TBoundAction<
  ActionTypes.SET_EVENT_TEAM_DETAILS_SUCCEEDED,
  TViewEventTeamDetailsSucceededParams
>;
type TActionEventTeamDetailsFailed = TBoundAction<
  ActionTypes.SET_EVENT_TEAM_DETAILS_FAILED,
  TViewEventTeamDetailsFailedParams
>;

type TSupportedActions =
  | TActionEventTeamDetailsRequested
  | TActionEventTeamDetailsSucceeded
  | TActionEventTeamDetailsFailed;

export type TActions = {
  setViewEventTeamDetailsRequested(params: TViewEventTeamDetailsRequestedParams): TActionEventTeamDetailsRequested;
  setViewEventTeamDetailsSucceeded(params: TViewEventTeamDetailsSucceededParams): TActionEventTeamDetailsSucceeded;
  setViewEventTeamDetailsFailed(params: TViewEventTeamDetailsFailedParams): TActionEventTeamDetailsFailed;
};

export const actions: TActions = {
  //
  // View Team Details
  //
  setViewEventTeamDetailsRequested(params: TViewEventTeamDetailsRequestedParams) {
    return { type: ActionTypes.SET_EVENT_TEAM_DETAILS_REQUESTED, payload: params };
  },

  setViewEventTeamDetailsSucceeded(params: TViewEventTeamDetailsSucceededParams) {
    return { type: ActionTypes.SET_EVENT_TEAM_DETAILS_SUCCEEDED, payload: params };
  },

  setViewEventTeamDetailsFailed(params: TViewEventTeamDetailsFailedParams) {
    return { type: ActionTypes.SET_EVENT_TEAM_DETAILS_FAILED, payload: params };
  }
};

//
// Reducer
//

function getInitialState(): TEventTeamsState {
  return {
    viewEventTeamDetails: {
      request: {} as TViewEventTeamDetailsRequestedParams,
      response: {} as TViewEventTeamDetailsSucceededParams,
      isRequested: false,
      isSucceeded: false,
      isErrored: false
    }
  };
}

export function reducer(state = getInitialState(), action: TSupportedActions): Partial<TEventTeamsState> {
  switch (action.type) {
    // team details
    case ActionTypes.SET_EVENT_TEAM_DETAILS_REQUESTED: {
      return {
        ...state,
        viewEventTeamDetails: {
          ...state.viewEventTeamDetails,
          request: action.payload,
          isRequested: true,
          isSucceeded: false,
          isErrored: false
        }
      };
    }
    case ActionTypes.SET_EVENT_TEAM_DETAILS_SUCCEEDED: {
      return {
        ...state,
        viewEventTeamDetails: {
          ...state.viewEventTeamDetails,
          response: action.payload.results,
          isRequested: false,
          isSucceeded: true,
          isErrored: false
        }
      };
    }
    case ActionTypes.SET_EVENT_TEAM_DETAILS_FAILED: {
      return {
        ...state,
        viewEventTeamDetails: {
          ...state.viewEventTeamDetails,
          isRequested: false,
          isSucceeded: false,
          isErrored: true,
          error: action.payload
        }
      };
    }
    default:
      return state;
  }
}
